export const EXCLUDED_PATHS =
  /^\/pages\/(profile\/(plans|users|subscription|invoices)|help)/;
